const SCORING_QUESTION_IDS = [9011, 9029, 9032, 9033, 9035, 9036, 9040, 9041];

const ARCHETYPES = [
    {
        maxScore: 26,
        title: 'The One Who Saw It All',
        emoji: 'crystal-ball',
        description: 'You noticed what everyone else missed. That’s where the best stories hide.'
    },
    {
        maxScore: 33,
        title: 'The Keeper of Secrets',
        emoji: 'old-key',
        description: 'You know the parts nobody else remembers (or admits to).'
    },
    {
        maxScore: 40,
        title: 'The Unwritten Bestseller',
        emoji: 'popcorn',
        description: 'Your book has been “coming soon” for years. Now you just talk.'
    }
];

const CHAPTER_QUESTIONS = [
    {
        questionId: 9046,
        byAnswerId: {
            1: 'Which city did you grow up in, and where weren’t you supposed to go?',
            2: 'What was your town called, and who started the best gossip?',
            3: 'Where was home out in the country, and what did you get away with?',
            4: 'Which move gave you your best story?',
            5: 'Where did you grow up, and what did you get away with there?'
        }
    },
    {
        questionId: 9047,
        byAnswerId: {
            1: 'Show us your dog. What did it get away with?',
            2: 'Show us your cat. Who did it like least?',
            3: 'What pet did you have, and what chaos did it cause?',
            4: 'No pets at home? So what did you beg for instead?',
            5: 'What’s your earliest memory that still makes you laugh?'
        }
    },
    {
        questionId: 9048,
        byAnswerId: {
            1: 'What did your mom or dad never tell you, but you found out anyway?',
            2: 'What did your grandparents never talk about at dinner?',
            3: 'What’s the worst trouble you and your siblings got into?',
            4: 'Who was your partner in crime, and what did you get up to?',
            5: 'Who was your favorite person as a kid, and what did you two get up to?'
        }
    }
];

export {
    SCORING_QUESTION_IDS,
    ARCHETYPES,
    CHAPTER_QUESTIONS
};
